module.exports = __webpack_public_path__ + "img/bg_about_experience1.9bbdb773.png";